import {Action, Module} from 'vuex-module-decorators';
import store from '@/store';
import {TimelineInteractionModel} from '@/models/timeline.model';
import {take} from 'rxjs/operators';
import {TimelineInteractionApi} from '@/api/timeline-interaction.api';
import {EntityStateAdapter} from '@/store/base.store';

export const featureKey = 'timeline_interactions';

// @ts-ignore
if (store.state.timeline_interactions) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class TimelineInteractionStoreModule extends EntityStateAdapter<TimelineInteractionModel> {
  get timelineInteraction(): TimelineInteractionModel[] {
    return this._entities;
  }

  @Action({commit: 'insertMany', rawError: true})
  async fetchAll(data: { challengerId: number, timelineId: number }): Promise<TimelineInteractionModel[]> {
    this.updateLoading(true);
    const response = await new TimelineInteractionApi(data.challengerId, data.timelineId)
      .allPaginated()
      .pipe(take(1))
      .toPromise();
    this.context.commit('updateAllPageParams', response);
    return response.data;
  }
}
